<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapp">
      <div class="row">
        <div class="col-12">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'address-book']" />
          </span>
          <h2>{{ $t('quarentines.pageTitle') }}</h2>
        </div>
      </div>
      <div class="row mt-2 pl-3"><strong>Pesquisar por</strong></div>
      <div class="row">
    <div class="col-12">
      <div class="form-inline">
        <b-form-select
          class="mt-3 mr-3"
          v-model="searchType"
          @change="setSearchType"
          :options="searchOptions"
        ></b-form-select>
        <div class="form-group col-3 mt-3 pl-0 pr-0">
          <input
            style="width: 100%;"
            type="text"
            class="form-control"
            :placeholder="$t('quarentines.searchInput')"
            @keyup="searchTerm"
            v-model="search"
          />
        </div>
        <button
          @click="
            search = null;
            setData();
          "
          type="button"
          class="btn btn-outline-primary mt-3 ml-1"
        >
          {{ $t('quarentines.searchButton') }}
        </button>
            <div class="col-7 text-right mt-3 pl-0 pr-0">
              <span class="labelQuarentine">
                {{ $t('quarentines.totalQuarentine') }}: {{ totalDocuments }}
              </span>
            </div>
          </form>
          <b-table
            striped
            id="manual-table"
            class="mt-4"
            :items="items"
            :fields="fields"
            :busy="loading"
            @sort-changed="sortingChanged"
            no-local-sorting
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Email -->
            <template v-slot:cell(email)="row">
              {{ row.item.email }}
            </template>
            <!-- Telefone -->
            <template v-slot:cell(phone)="row">
              {{ row.item.phone }}
            </template>
            <!-- Client ID -->
            <template v-slot:cell(clientId)="row">
              {{ row.item.clientId }}
            </template>
            <!-- type -->
            <template v-slot:cell(type)="row">
              {{ checkQuarentineType(row.item) }}
            </template>
            <!-- Ação -->
            <template v-slot:cell(actionId)="row">
              {{ checkActionName(row.item) }}
            </template>
            <!-- Data Quarentena -->
            <template v-slot:cell(createdAt)="row">
              {{ dateFormat(new Date(row.item.createdAt)) }}
            </template>
            <!-- Data Expiração -->
            <template v-slot:cell(expirationDate)="row">
              {{ dateFormat(new Date(row.item.expirationDate)) }}
            </template>
            <template v-slot:cell(actions)="row">
              <div class="buttons-area" style="min-width: 90px;">
                <button
                  class="btn btn-outline-danger"
                  @click="removeQuarentine(row.item)"
                >
                  <font-awesome-icon :icon="['fas', 'trash-alt']" />
                </button>
              </div>
            </template>
          </b-table>
          <div v-show="!loading" class="footer">
            <div class="pagination-area-quarentines mt-1">
              <paginate
                :pageCount="documents"
                :clickHandler="setData"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              ></paginate>
            </div>
            <div id="icons" class="row mr-2">
              <div class="mr-3">
                <div
                  v-if="loadingDownloadIconCsv"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a v-else :title="$t('quarentines.exportCsv')">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none dropdown-csv"
                    no-caret
                  >
                    <template #button-content>
                      <span class="xls">
                        <i class="fas fa-file-csv"></i>
                      </span>
                    </template>
                    <b-dropdown-item @click="exportData('csv', 'comma')">{{
                      $t('quarentines.csvCommaSeparator')
                    }}</b-dropdown-item>
                    <b-dropdown-item @click="exportData('csv', 'pipe')">{{
                      $t('quarentines.csvPipeSeparator')
                    }}</b-dropdown-item>
                  </b-dropdown>
                </a>
              </div>
              <div>
                <div
                  v-if="loadingDownloadIconXls"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a
                  v-else
                  @click="exportData('xlsx', null)"
                  :title="$t('quarentines.exportXls')"
                >
                  <span class="xls">
                    <i class="fas fa-file-excel"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import dashboardBar from '@/components/molecules/dashboard-bar';
import api from '@/services/api';

export default {
  name: 'Clients',
  components: {
    Paginate,
    dashboardBar,
  },

  data: () => ({
    sortBy: null,
    sortDesc: null,
    downloadType: null,
    userAuth: null,
    typingTimer: null,
    doneTypingInterval: 600,
    search: null,
    loading: true,
    page: 1,
    loadingDownloadIconXls: false,
    loadingDownloadIconCsv: false,
    dates: {
      start: null,
      end: null,
    },
    fields: [],
    items: [],
    documents: 0,
    totalDocuments: 0,
    searchOptions: [],
    searchType: 'email', // default
  }),

  watch: {
    actionGroupData: function watchactionGroup() {
      this.setData();
    },
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },
    calendarDates: function watchCalendarDates() {
      this.setData();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('authentication', ['userProfile']),
  },

  methods: {
    ...mapActions('calendar', ['setDates']),

    setSearchType(value) {
      this.searchType = value;
    },

    checkUserData(value) {
      if (this.userProfile.permissions.clients.anonymous_profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    checkQuarentineType(item) {
      if (item.companyId) {
        return this.$t('quarentines.company');
      }
      return this.$t('quarentines.action');
    },

    checkActionName(item) {
      if (item.actionId) {
        return item.actionId.name;
      }
      return null;
    },

    async deleteQuarentine(quarantinedItem) {
      try {
        await api.post('/delete-quarentine', quarantinedItem, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        swal({
          title: this.$t('quarentines.messages.removeOk.title'),
          text: this.$t('quarentines.messages.removeOk.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('quarentines.messages.error.title'),
          text: this.$t('quarentines.messages.error.description'),
          icon: 'error',
        });
      }
      this.setData();
    },

    removeQuarentine(quarantinedItem) {
      swal({
        title: this.$t('quarentines.messages.removeQuarentine.title'),
        text: this.$t('quarentines.messages.removeQuarentine.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          this.deleteQuarentine(quarantinedItem);
        }
      });
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setData();
    },

    async searchTerm() {
      if (this.search !== '' && this.search !== null && this.searchType !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.setData, this.doneTypingInterval);
      }

      if (this.search === '') {
        this.search = null;
        this.setData();
      }
    },

    async setData(page) {
      this.loading = true;

      const response = await api.get('/quarentines', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          groupId: this.actionGroupData._id,
          search: this.search,
          page: page || this.page,
          limit: 10,
          sortDesc: this.sortDesc,
          sortBy: this.sortBy,
          searchType: this.searchType,
        },
      });
      this.loading = false;
      this.items = response.data.items;
      this.documents = response.data.documents;
      this.totalDocuments = response.data.totalDocuments;
    },

    async exportData(type, csvSeparator) {
      // checks if the total docs to download is greater then 500k
      if (this.documents * 10 > 500000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else {
        this.loadingDownloadIconCsv = true;
      }

      if (csvSeparator === 'comma') {
        csvSeparator = ',';
      }
      if (csvSeparator === 'pipe') {
        csvSeparator = '|';
      }

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        await api.get(
          `${this.apiServerlessDownloads}/quarentines/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              actionId: this.myActionsIds.length === 0 ? null : JSON.stringify(this.myActionsIds),
              groupId: this.actionGroupData._id,
              search: this.search,
              csvSeparator,
            },
          },
        );

        swal({
          title: this.$t('quarentines.messages.export.title'),
          text: this.$t('quarentines.messages.export.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('quarentines.messages.error.title'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
      });
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.clients.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
    this.fields = [
      {
        key: 'email',
        label: this.$t('quarentines.quarentinesTable.labels.email'),
      },
      {
        key: 'phone',
        label: this.$t('quarentines.quarentinesTable.labels.phone'),
      },
      {
        key: 'clientId',
        label: this.$t('quarentines.quarentinesTable.labels.clientId'),
      },
      {
        key: 'type',
        label: this.$t('quarentines.quarentinesTable.labels.type'),
      },
      {
        key: 'actionId',
        label: this.$t('quarentines.quarentinesTable.labels.action'),
      },
      {
        key: 'createdAt',
        label: this.$t('quarentines.quarentinesTable.labels.quarentineDate'),
      },
      {
        key: 'expirationDate',
        label: this.$t('quarentines.quarentinesTable.labels.expireDate'),
      },
      {
        key: 'actions',
        label: this.$t('quarentines.quarentinesTable.labels.actions'),
      },
    ];

    this.searchOptions = [

      {
        text: this.$t('clients.clientsTable.searchOptions.clientId'),
        value: 'clientId',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.email'),
        value: 'email',
      },
      {
        text: this.$t('clients.clientsTable.searchOptions.phone'),
        value: 'phone',
      },
    ];
  },


  mounted() {
    this.setData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';



.wrapper {
  padding: 8px;
}

#icons{
  margin-left: 1rem;
}

.wrapp {
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $gray-light;
  @each $i in $directions {
    @extend %default-padding-#{$i};
  }
  @extend %half-padding-bottom;

  h2 {
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 100;
    color: $gray;
  }

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }

  .refresh-icon {
    margin-top: 1px;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: green;
    }
  }
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-quarentines >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-quarentines .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-quarentines a {
  outline: none;
}
.labelQuarentine {
  font-size: 20px;
  color: #bdbdbd;
}
.dropdown-csv {
  border: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/quarentines/index.vue